// extracted by mini-css-extract-plugin
export default {"container":"globals_container__FTNXJ","visually-hidden":"globals_visually-hidden__dMhnZ"};